import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import OptInItem from './OptInItem/OptInItem';
import drivenFiLogo from './logos/Drivenfi_BlackPink.png';
import getOEMImage from './getOEMImage';
import vitalityLogo from './logos/Vitality_100x72.png';
import styles from './OptInBox.scss';

class OptInBox extends Component {
  static propTypes = {
    optInData: PropTypes.shape({
      zuto: PropTypes.exact({
        isOptedIn: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
        handleValueChange: PropTypes.func,
        error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
      }),
      oem: PropTypes.shape({
        campaignData: PropTypes.object,
        displayName: PropTypes.string,
        image: PropTypes.string,
        isOptedIn: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
          .isRequired,
        handleValueChange: PropTypes.func.isRequired,
        error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
      }),
      vitality: PropTypes.exact({
        isOptedIn: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
        handleValueChange: PropTypes.func,
        error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
      })
    })
  };

  generateDescription = (descriptionTemplate, url) => {
    if (descriptionTemplate) {
      const hasPrivacyNotice = descriptionTemplate.match('[privacy notice]');
      const description = descriptionTemplate.split('[privacy notice]');

      if (hasPrivacyNotice) {
        return [
          <span key="descFirst">{description[0]}</span>,
          <a key="link" target="_blank" rel="noopener noreferrer" href={url}>
            privacy notice
          </a>,
          description[1] && <span key="descLast">{description[1]}</span>
        ];
      } else {
        return [<p key="desc">{descriptionTemplate}</p>];
      }
    }
  };

  render() {
    const { optInData } = this.props;
    const { zuto, oem, vitality } = optInData;
    const make = oem && oem.displayName;

    if (!zuto && !oem && !vitality) {
      return null;
    }

    return (
      <div className={styles.container}>
        {oem && (
          <OptInItem
            fieldName="campaignOptIn"
            handleValueChange={oem.handleValueChange}
            isOptedIn={oem.isOptedIn}
            errorMessage={oem.error}
            icon={make ? getOEMImage(make.toLowerCase()) : oem.image}
            title={oem.campaignData.popupTitle}
            description={this.generateDescription(
              oem.campaignData.popupDescription,
              oem.campaignData.privacyNotice
            )}
          />
        )}
        {zuto && (
          <OptInItem
            fieldName="zutoOptIn"
            handleValueChange={zuto.handleValueChange}
            isOptedIn={zuto.isOptedIn}
            errorMessage={zuto.error}
            icon={drivenFiLogo}
            title="Are you looking to finance your next car? Our trusted partner Driven Finance, offers car finance products tailored to you."
            description={[
              <span key="descZuto">
                <strong>
                  By selecting {`"Yes,"`} you consent to us sharing your contact
                  details with Driven finance
                </strong>
                , who will reach out via email, SMS, or phone. You can withdraw
                your consent at any time by following the instructions in their
                full{' '}
              </span>,
              <a
                key="linkZuto"
                href="https://drivenfi.co.uk/privacy-policy/?utm_source=Whatcar%20API&utm_medium=Website&utm_campaign=Valuations&utm_content=Privacypolicy"
                target="_blank"
                rel="noopener noreferrer"
              >
                privacy notice.
              </a>
            ]}
          />
        )}
        {vitality && (
          <OptInItem
            fieldName="vitalityOptIn"
            handleValueChange={vitality.handleValueChange}
            isOptedIn={vitality.isOptedIn}
            errorMessage={vitality.error}
            icon={vitalityLogo}
            title="We’ve partnered with Vitality car insurance to help you save money on your insurance."
            description={[
              <span key="descVitality">
                If you’d like us to share your contact details with Vitality,
                they’ll get in touch with you directly by email and phone. With
                Vitality you can earn money back every month when you drive well
                or have car-free days. You can withdraw your consent at any time
                by using their{' '}
              </span>,
              <a
                key="linkVitality"
                href="https://www.vitality.co.uk/privacy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                full privacy notice
              </a>
            ]}
          />
        )}
      </div>
    );
  }
}

export default OptInBox;



// WEBPACK FOOTER //
// ./src/components/OptIn/OptInBox.js